import * as ResizablePanels from 'react-resizable-panels'

type ResizablePanelsCompat = typeof ResizablePanels & {
  Group?: typeof ResizablePanels.PanelGroup
  Separator?: typeof ResizablePanels.PanelResizeHandle
}

const compat = ResizablePanels as ResizablePanelsCompat

function requiredExport<T>(component: T | undefined, name: string): T {
  if (!component) {
    throw new Error(`react-resizable-panels export missing: ${name}`)
  }
  return component
}

export const Panel = compat.Panel
export const PanelGroup = requiredExport(compat.PanelGroup ?? compat.Group, 'PanelGroup/Group')
export const PanelResizeHandle = requiredExport(
  compat.PanelResizeHandle ?? compat.Separator,
  'PanelResizeHandle/Separator',
)
